import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.UserNotificationsRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about users
 * using http requests.
 */
export default class UserNotificationsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.UserNotificationsRestService#getAllAsync
     * @methodOf rest.services.UserNotificationsRestService
     * @function
     *
     * @description
     * Retrieves the logged user and his friends.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync('user-notifications/');

    }

    /**
     * @ngdoc function
     * @name rest.services.UserNotificationsRestService#update
     * @methodOf rest.services.UserNotificationsRestService
     * @function
     *
     * @description
     * Updates a resource
     *
     * @param {string} userId UserId identifier
     * @param {object} payload Resource payload
     * @param {string} path API Resource path
     *
     * @returns {Promise} The promise of the call.
     */
    update(userId, userPayload, headers) {

        return super.update(userId, userPayload, 'user-notifications/', headers);

    }

}

_serviceDependencies.push(UserNotificationsRestService);

angular.module('rest.services')
    .service('UserNotificationsRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/userNotificationsRestService.js